<template>
  <div
    ref="background"
    class="background"
    @click="onBackgroundClick"
    @contextmenu.prevent="showContextMenu($event)"
  >
    <div class="welcome limit-width hide-scrollbar" :class="[(tips.show)?'in-tips':'',(tips.story.show)?'in-story':'' ]" style="width:100%; max-width:600px;">
      <img src="" alt="">
      <template v-if="loader.loaded && !loader.show">
        <v-container
          ref="messages-view-area"
          class="messages-view-area"
          fluid
          style="padding: 10px;"
        >
          <v-row style="height: 50px;">
            <!-- 訊息最上面的預留空間 -->
          </v-row>
          <v-row>
            <v-col class="msg mb-2" cols="12">
              <template v-for="(record,i) in game.history">
                <!-- 最後一則會跟writer的訊息重複，所以不顯示 -->
                <div v-if="!((i === game.history.length - 1) && record.type !== 'user')" :key="i">
                  <v-row
                    v-if=" record.type === 'user'"
                    class="player-message"
                    :key="i"
                  >
                    <v-col class="message-col">
                      <v-card
                        class="card-container message-card player"
                        v-html="record.message._contentHtml"
                      ></v-card>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="record.type !== 'user'"
                    class="creater-message"
                    :key="i"
                    :class="[
                      ( record.message.sender === '$narrator' ) ? 'narrator' : '',
                      ( i > 0 && game.history[i-1].message.sender === record.sender) ? 'repeat-creater' : '' ,
                      ( game.history[i+1] && game.history[i+1].message.sender != record.sender) ? 'last-message' : '',
                    ]"
                  >
                    <v-col class="avatar-col" v-if="record.message.sender !== '$narrator'">
                      <div class="creater-icon"></div>
                    </v-col>
                    <v-col class="message-col">
                      <div
                        v-if="record.message.sender !== '$narrator'"
                        class="message-sender"
                      >{{ getRoleName(record.message.sender) }}</div>
                      <v-card class="card-container message-card">{{record.message._contentHtml}}</v-card>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <!-- 當前播放中的 Message -->
              <v-row
                v-if="currentMessage"
                ref="currentMsg"
                class="creater-message last-message"
                :class="[
                  ( currentMessage.sender === '$narrator' ) ? 'narrator' : ''
                ]"
              >
                <v-col class="avatar-col" v-if="currentMessage.sender !== '$narrator'">
                  <div class="creater-icon"></div>
                </v-col>
                <v-col class="message-col">
                  <div
                    v-if="currentMessage.sender !== '$narrator'"
                    class="message-sender"
                  >{{ getRoleName(currentMessage.sender) }}</div>
                  <v-card class="card-container message-card">
                    <message-writer
                      ref="messageWriter"
                      :message="currentMessage"
                      :game="game"
                      @update="onWriterUpdate"
                      @click="onClickWriter()"
                      @complete="onWriterComplete"
                    ></message-writer>
                  </v-card>
                </v-col>
              </v-row>

              <!-- 如果Message 有tips 在writer結束後出現 -->
              <v-row v-if="tips.show"
                class="system-tips"
              >
                <v-col class="message-tips tips-container">
                    <span class="icon-tips"></span>
                    <span>
                      {{tips.hint}}
                    </span>
                </v-col>
              </v-row>

              <!-- 如果Message 有hint 在writer結束後出現 -->
              <v-row
                class="system-hint"
                v-if="!loader.show  && currentMessage && currentMessage.hint && hint.showIfWriterComplete "
                @click.stop="complateOrContinue()"
              >
                <v-col class="message-col" :class=" (hint.opened)?'full-wid':'' ">
                  <v-card
                    v-if="!hint.opened"
                    class="card-container message-card"
                    v-on:click="openhint(currentMessage)"
                  >
                    <span class="icon-hint"></span>
                    <span class="icon-chest"></span>
                  </v-card>
                  <v-card v-if="hint.opened" class="card-container message-card opened">
                    <span class="icon-chest"></span>
                    <div class="hint-content">
                      <div class="icon-hint"></div>
                      {{currentMessage.hint}}
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- 在有"next"且沒有"選項"的情況下顯示提示訊息 -->
              <transition name="fade">
                <div
                  v-if="currentMessage && currentMessage.selections.length === 0 && nextMessagePath && writerComplete"
                  style="textAlign:center;"
                >
                  <div
                    class="content"
                    style="background-color:black; margin-top:24px; opacity:0.4;"
                  >tap</div>
                </div>
              </transition>
              <div ref="space" @click.stop="complateOrContinue()" style="height: 200px;"></div>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <!-- #Loader -->
      <transition name="fade">
        <v-dialog v-model="loader.show" hide-overlay :persistent="!loader.loaded" max-width="300">
          <v-card color="secondary">
            <v-card-text class="white--text" style="padding-top: 15px">
              <transition name="fade">
                <div v-if="!loader.loaded">
                  <span v-text="loader.text"></span>
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </div>
              </transition>
              <div style="margin-top: 5px; text-align: center;">
                <v-btn style="opacity: 0.7;" @click="loader.show = false" :disabled="!loader.loaded">START</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </transition>
      <v-menu
        v-model="contextmenu.show"
        :position-x="contextmenu.x"
        :position-y="contextmenu.y"
        fixed
        offset-y
      >
        <v-list>
          <v-list-item @click="saveHistory()">
            <v-list-item-content>
              <v-list-item-title>save playback</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <tips-story
        ref="tip-story"
        v-model="tips.show"
        :target="tips.target"
        :teller="tips.teller"
        :question="tips.question"
        :contents="tips.story.contents"
        :warningMessage="tips.warningMessage"
      >
      </tips-story>
    </div>
  </div>
  <!-- .background -->
</template>
<script>
// import { VueTyper } from 'vue-typer'
import Assistant from '@/lib/Assistant'
import Player from '@/lib/Player'
import Game from '@/lib/Game'
import Message from '@/lib/Message'
import MessageWriter from '@/components/MessageWriter'
import TipsStory from '@/components/Game/Tipsstory'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
import avatorImg from '@/assets/img/avators/img-creater-01.svg'
let assistant = Assistant.getInstance()

export default {
  name: 'game',
  components: {
    MessageWriter,
    TipsStory
  },
  computed: {
    currentMessage(msg, old) {
      return this.game.currentMessage
    },
    nextMessagePath(msg) {
      if (this.currentMessage.next) {
        if (!this.currentMessage.next.includes('/')) {
          return `${this.game.currentScene.id}/${this.currentMessage.next}`
        }
        return this.currentMessage.next
      } else if (this.currentMessage.autoNext) {
        let msgs = this.game.currentScene.messages
        let i = msgs.findIndex((msg) => msg === this.currentMessage)
        if (i >= 0 && msgs[i + 1]) {
          return `${this.game.currentScene.id}/${msgs[i + 1].id}`
        }
        return null
      } else {
        return null
      }
    }
  },
  watch: {
    'loader.show'(show) {
      if (!show) {
        this.gameStart()
      }
    },
    currentMessage(msg, old) {
      this.writerComplete = false
      this.hint.showIfWriterComplete = false
      this.hint.opened = false
      if (msg) {
        msg.splitContent()
        // console.log('currentMessage', msg)
        msg.beforeDisplay(this.game, msg, old)
        if(msg && msg.selections.length > 0 && msg.selectMode === 'advance'){
          this.initTipsStory(msg)
        }else{
          this.clearTipsStory()
        }
        this.game.emit('change-message', msg, old)
      }
    },
    userResponseText() {
      if (this.$userResponseUpdate) {
        clearTimeout(this.$userResponseUpdate)
      }
      if (this.userResponseText) {
        console.log(this.userResponseText)
        console.log(this.game)
        this.$userResponseUpdate = setTimeout(() => {
          this.$userResponseUpdate = null
          this.userResponseText = ''
        }, 2000)
      }
    }
  },
  data: () => {
    return {
      screenplay: null,
      game: new Game(new Player({ id: 'MAIN' }), assistant),
      /**
       * 已經按下開始按鈕
       * @type {boolean}
       */
      startFlag: false,
      /**
       * 用戶的回覆
       * 會顯示在左下角
       * @type {string}
       */
      userResponseText: '',
      defaultTypeDelay: 70,
      typeDelay: 70,
      writerComplete: false,
      // 會在底下出現的迷你對話窗口
      hint: {
        show: false,
        content: '',
        label: '',
        showIfWriterComplete: false,
        opened: false
      },
      tips: {
        show: false,
        teller: '', // 暫時無視該屬性
        hint: '', // 暫時無視該屬性
        question: '',
        target: null,
        warningMessage: null, // 使用預設訊息
        story: {
          show: false,
          contents: []
        }
      },
      contextmenu: {
        x: 0,
        y: 0,
        show: false
      },
      loader: {
        text: 'Loading',
        show: true,
        loaded: false
      },
      limitWidthStyle: {},
      leftMargin: 0,
      playerInput: ''
    }
  },
  mounted() {
    console.log('new game mounted', avatorImg)
    this.$store.commit(
      'appbar/backTo',
      `/screenplay/${this.$route.query.sid || 'test'}`
    )
    this.$store.commit('appbar/setOptions', [
      {
        key: 'save-playback',
        text: 'save Playback'
      }
    ])
    if (this.$route.query.appbar === 'hide') {
      this.$nextTick(() => {
        this.$store.commit('appbar/toggle', false)
      })
    }
    this.$onOptionClick = this.onOptionClick.bind(this)
    this.$bus.$on('appbar-option-click', this.$onOptionClick)
    // TODO 改成跟 service 要求檔案
    util
      .delay(200)
      .then(async () => {
        this.screenplayId = this.$route.query.sid || 'test'
        this.screenplay = await gameLoader.loadScreenplay(this.screenplayId)
        await gameLoader.preloadResource(this.screenplay)
        this.loader.loaded = true
      })
      .catch((e) => {
        console.error(e)
      })
    this.game.on('tips-story-init', (e)=>{
      this.initTipsStory(e.message, {
        warningMessage: e.tips.warn ? e.tips.warn : null
      })
      this.tips.story.contents.push(e.query)
    })
    this.game.on('tips-story-close', (e)=>{
      this.clearTipsStory()
    })
    /*
     * 用於檢查interactiveCanvas從parent frame傳過來的資料
     * 另外也用於跟GameDev的"外框"溝通
     */
    this.$onMessage = util.messageLogger
    window.addEventListener('message', this.$onMessage, false)
  },
  beforeDestroy() {
    this.game.removeAllListeners('tips-story-init')
    this.$bus.$off('appbar-option-click', this.$onOptionClick)
    window.removeEventListener('message', this.$onMessage)
  },
  methods: {
    gameStart() {
      if (!this.startFlag) {
        this.game.installScreenplay(this.screenplay)
        console.log(this.screenplay)
        this.startFlag = true
        this.loader.show = false
        if (window.parent !== window) {
          setTimeout(() => {
            window.parent.postMessage({
              type: 'wordprison',
              event: 'game.start'
            })
            console.log('postMessage: game.start')
          }, 100)
        }
        assistant.setup()
        assistant.addCallback('$ANY', (data) => {
          this.onUserInput(data)
        })
      }
    },
    onWriterUpdate() {
      this.scrollToBottom()
    },
    onWriterComplete() {
      this.writerComplete = true
      this.hint.showIfWriterComplete = true
    },
    onClickWriter() {
      this.complateOrContinue()
    },
    onBackgroundClick(e) {
      let bg = this.$refs.background
      let space = this.$refs.space
      let container = this.$refs['messages-view-area']
      console.log(e.toElement)
      if (
        e.toElement === container ||
        e.toElement === bg ||
        e.toElement === space
      ) {
        this.complateOrContinue()
      } else {
        this.complateTyper()
      }
    },
    scrollToBottom() {
      let msgDiv = this.$refs.currentMsg
      if (msgDiv) {
        msgDiv.scrollIntoView({ block: 'start' })
        if (this.$store.state.appbar.fixed) {
          window.scrollBy(0, 0 - this.$store.state.topMargin)
        }
      }
      // window.scrollTo(0, bg.scrollHeight)
    },
    complateOrContinue() {
      console.log('complateOrContinue', this.writerComplete)
      if (this.writerComplete) {
        this.btnContinue()
      } else {
        this.complateTyper()
      }
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    complateTyper() {
      let messageWriter = this.$refs.messageWriter
      if (messageWriter) {
        messageWriter.complete()
      }
    },
    btnContinue() {
      if (this.currentMessage) {
        if (this.currentMessage.selections.length > 0) {
          this.game.emit('game-event', {
            type: 'button-next',
            data: this.currentMessage.next
          })
        } else if (typeof this.currentMessage.next === 'string') {
          this.game.to(this.currentMessage.next)
        } else if (this.currentMessage.autoNext) {
          this.game.nextMessage()
        } else {
          this.game.emit('game-event', {
            type: 'button-next',
            data: this.currentMessage.next
          })
        }
      }
    },
    btnBack() {
      if (this.currentMessage && this.currentMessage.back) {
        if (typeof this.currentMessage.back === 'string') {
          this.game.to(this.currentMessage.back)
        } else {
          this.game.emit('game-event', {
            type: 'button-back',
            data: this.currentMessage.back
          })
        }
      }
    },
    onUserInput(data) {
      if (data.query) {
        // 指令觸發的事件跟用戶說話不同
        if (data.query.indexOf('cmd/') === 0) {
          this.game.emit('agent-event', data)
        } else {
          this.userResponseText = data.query
          if(this.tips.show){
            this.tips.story.contents.push(data.query)
            if(this.tips.story.contents.length >= 2){
              this.tips.story.show = true
            }
          }
          let msg = this.currentMessage
          if(msg && msg.data.tips){
            this.$set(msg.data, 'tips', msg.data.tips)
          }
          this.game.emit('user-input', data)
        }
      }
    },
    onOptionClick(option) {
      console.log(option)
      switch (option.key) {
        case 'save-playback':
          this.saveHistory()
          break
      }
    },
    showContextMenu() {
      this.contextmenu.show = true
      this.contextmenu.x = event.clientX + 10
      this.contextmenu.y = event.clientY - 50
    },
    /**
     * 將"特殊的角色"轉換為"可顯示的名稱"
     */
    getRoleName(name){
      // TODO 這邊之後可能會需要根據語系的不同做額外調整
      return Message.getRoleName(name) || name
    },
    saveHistory() {
      gameLoader.saveGameRecord(this.screenplay.id, {
        uid: 'test',
        history: this.game.generateGameRecord()
      })
    },
    openhint(message) {
      this.hint.opened = true
    },
    onPlayerInput() {
      this.onUserInput(this.playerInput)
      this.playerInput = ''
    },
    initTipsStory(msg, opts = {}){
      this.tips.show = true
      this.tips.question = msg._contentHtml
      this.tips.target = msg
      this.tips.story.contents = []
      if(opts.warningMessage){
        this.tips.warningMessage = opts.warningMessage
      }
    },
    clearTipsStory(){
      this.tips.show = false
      this.tips.question = ''
      this.tips.target = null
      this.tips.story.contents = []
      this.tips.story.show = false
    },
    showTipsState(){
      this.tips.show = true
    },
    showTipsStoryState(){
      this.tips.story.show = true
    },
    offTipsState(){
      this.tips.show = false
      this.tips.story.show = false
    }
  }
}
</script>
<style>
.vue-typer .custom.char {
  color: white;
}
</style>
<style scoped>
  @import '../style/game.css';
</style>
